import { useQuery } from "@tanstack/react-query";
import { unlockScheduleQueryOptions } from "@/services/queries/tokenPage/utilityValueQueries";
import type { useUnlockSchedule } from "@/types/tokenDashboard/utilityTab";

export function useUnlockSchedule(tokenId: string): useUnlockSchedule {
  const query = useQuery({
    ...unlockScheduleQueryOptions(tokenId),
    enabled: !!tokenId,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
